import { NavigateFunction } from 'react-router-dom';
import { savaquanFetchJson } from '../../../shared/services/http.service';
import {
  SendCommunicationDto,
  SendCommunicationResponseDto,
  MessageContentResponseDto,
  SendCommunicationParams,
  DocumentType,
  mapDocumentTypeToCommunicationType,
} from '../dtos/communication.dto';

export async function sendCommunication(
  navigate: NavigateFunction,
  params: SendCommunicationParams
): Promise<SendCommunicationResponseDto> {
  const emailAddresses = params.deliveryChannels.includes('email')
    ? params.recipients.filter(r => r.email).map(r => r.email!)
    : [];

  const phoneNumbers = params.deliveryChannels.includes('sms')
    ? params.recipients.filter(r => r.phoneNumber).map(r => r.phoneNumber!)
    : [];

  // An invoice or a receipt is tied to its invoice, as Android sends it: the
  // server marks the invoice Sent (or its receipt sent) only from that id.
  const invoiceDocument =
    params.documentType === 'invoice' || params.documentType === 'receipt';

  const dto: SendCommunicationDto = {
    emailAddresses,
    phoneNumbers,
    subject: params.subject,
    emailBody: params.emailBody,
    smsBody: params.smsBody,
    communicationType: mapDocumentTypeToCommunicationType(params.documentType, params.isFollowUp),
    associatedEstimateId: params.documentType === 'estimate' ? params.documentId : undefined,
    associatedInvoiceId: invoiceDocument ? params.documentId : undefined,
  };

  return savaquanFetchJson<SendCommunicationResponseDto>(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/communication/send`,
    {
      navigate,
      method: 'POST',
      body: JSON.stringify(dto),
    }
  );
}

export async function getMessageContent(
  navigate: NavigateFunction,
  documentType: DocumentType,
  documentId: number,
  isFollowUp: boolean = false
): Promise<MessageContentResponseDto> {
  const communicationType = mapDocumentTypeToCommunicationType(documentType, isFollowUp);
  const idParam =
    documentType === 'invoice' || documentType === 'receipt'
      ? `invoiceId=${documentId}`
      : `estimateId=${documentId}`;

  return savaquanFetchJson<MessageContentResponseDto>(
    `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/communication/content?${idParam}&communicationType=${communicationType}`,
    {
      navigate,
      method: 'GET',
    }
  );
}
